// @flow
import React, { Fragment, Component } from 'react';

import Connect from '@rover/react-lib/components/utils/Redux/Connect';
import CreditCardForm from '@rover/react-lib/components/forms/CreditCardForm';
import { selectors as addressSelectors } from '@rover/react-lib/redux/ducks/address.duck';
import {
  effects as creditCardEffects,
  selectors as creditCardSelectors,
} from '@rover/react-lib/redux/ducks/creditCards.duck';
import { selectors as countryConfigurationSelectors } from '@rover/react-lib/redux/ducks/countryConfiguration.duck';
import { selectors as frontendConfigurationSelectors } from '@rover/react-lib/redux/ducks/frontendConfiguration.duck';

import { type ContainerProps } from './container.constants';

type Props = ContainerProps<
  typeof CreditCardForm,
  {
    onChange: string => void,
    validationErrors: any,
    shouldSetDefaultCardOnChange?: boolean,
    centerButtons?: boolean,
    saveButtonText?: string,
  }
>;

type FormResetterProps = {
  defaultCardId: string,
  onChange: string => void,
};

const selector = state => ({
  address: addressSelectors.getAddress(state),
  loading: creditCardSelectors.getLoading(state),
  creditCards: creditCardSelectors.getCreditCards(state),
  errorMessage: creditCardSelectors.getErrorMessage(state),
  defaultCardId: creditCardSelectors.getDefaultCreditCardId(state),
  getStateFieldNameByPostalCode: countryConfigurationSelectors.getStateFieldNameByPostalCode(state),
  isStateFieldRequiredByPostalCode: countryConfigurationSelectors.getIsStateRequiredByPostalCode(
    state
  ),
  fullPostalRegExp: countryConfigurationSelectors.getCombinedRegex(state),
  partialPostalRegExp: countryConfigurationSelectors.getCombinedPartialRegex(state),
  supportedCountryCodes: countryConfigurationSelectors.getCountryCodes(state),
  isSubmitting: creditCardSelectors.getLoading(state),
  language: frontendConfigurationSelectors.getLanguage(state),
});

const effects = {
  onAddCard: creditCardEffects.saveCreditCard,
  onSelectCard: creditCardEffects.setDefaultCreditCard,
  onDeleteCard: creditCardEffects.removeCreditCard,
};

class FormResetter extends Component<FormResetterProps> {
  componentDidUpdate(prevProps: FormResetterProps) {
    // if the default card changes from the API, reset the
    // selected card to be that default
    if (prevProps.defaultCardId !== this.props.defaultCardId) {
      this.props.onChange(this.props.defaultCardId);
    }
  }

  render() {
    return null;
  }
}

const CreditCardFormContainer = ({
  onChange,
  selectedCardId,
  validationErrors,
  shouldSetDefaultCardOnChange,
  ...other
}: Props) => (
  <Connect selector={selector} effects={effects}>
    {({ onSelectCard, creditCards, defaultCardId, ...otherConnectedProps }) => (
      <Fragment>
        <CreditCardForm
          creditCards={creditCards}
          selectedCardId={selectedCardId}
          onChange={cardId => {
            onChange(cardId);
            if (shouldSetDefaultCardOnChange) {
              onSelectCard(cardId);
            }
          }}
          hideAddCardCancelButton={creditCards.length === 0}
          {...otherConnectedProps}
          {...other}
        />
        <FormResetter defaultCardId={defaultCardId} onChange={onChange} />
      </Fragment>
    )}
  </Connect>
);

CreditCardFormContainer.defaultProps = {
  shouldSetDefaultCardOnChange: true,
};

export default CreditCardFormContainer;



// WEBPACK FOOTER //
// ../react-lib/src/containers/CreditCardFormContainer.jsx